// Add the Firebase products that you want to use
import "firebase/analytics";
import "firebase/auth";
import "firebase/firestore";
import "firebase/performance";
import "firebase/storage";

// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from "firebase/app";

export const functionsUrl =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5001/edenic-game/europe-west1/"
    : "https://europe-west1-edenic-game.cloudfunctions.net/";

// Firebase config file
const firebaseConfig = {
  apiKey: "AIzaSyBTpjjHSdpcYtI3qhmsCi0yOzOrgISRiso",
  authDomain: "edenic-game.firebaseapp.com",
  databaseURL: "https://edenic-game.firebaseio.com",
  projectId: "edenic-game",
  storageBucket: "edenic-game.appspot.com",
  messagingSenderId: "583911719276",
  appId: "1:583911719276:web:87d02c6d9360faf3183349",
  measurementId: "G-H7HFN0KP6K",
};

// Initialise Firebase if not already initialised
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export const app = firebase.app();

export const analytics = app.analytics();
export const performance = app.performance();

export const firestore = app.firestore();

// export const functions = app.functions("europe-west1");

// firebase.analytics();
// firebase.firestore();
// firebase.performance();
//   .catch(function(err: any) {
//     if (err.code === 'failed-precondition') {
//       // Multiple tabs open, persistence can only be enabled in one tab at a a time.
//     } else if (err.code === 'unimplemented') {
//       // The current browser does not support all of the features required to enable persistence
//     }
//   })

if (process.env.NODE_ENV !== "production") {
  firestore.useEmulator("localhost", 8080);
  // functions.useEmulator("localhost", 5001);
}
